export const comments_5689022 = {"data":{"data":[],"links":{}}}